(function () {
  const banner = document.getElementById('accessibility-banner');
  if (!banner) return;

  const duration = parseInt(banner.dataset.duration, 10);
  const dismissTimer = setTimeout(function () {
    dismiss();
  }, duration);

  banner.addEventListener('click', function () {
    clearTimeout(dismissTimer);
    dismiss();
    smoothScrollTo(document.body.scrollHeight);
    setTimeout(function () {
      smoothScrollTo(document.body.scrollHeight);
    }, 750);
  });

  function smoothScrollTo(endY) {
    var startY = window.scrollY;
    var startTime = null;
    var animDuration = 700;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / animDuration, 1);
      var eased = 0.5 - Math.cos(progress * Math.PI) / 2;
      window.scrollTo(0, startY + (endY - startY) * eased);
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function dismiss() {
    banner.classList.add('is-hidden');
    setTimeout(function () {
      banner.style.display = 'none';
    }, 650);
  }
})();
